/*
* Copyright © 2021 Firecrest Clinical, Ltd.
* All rights reserved.
*/

import {Component, Input, ViewEncapsulation} from '@angular/core';
import {FcResponsiveAgGridOptions} from './fc-responsive-ag-grid-options';

/**
 * Grid component with Angular.
 */
@Component({
    selector: 'fc-responsive-ag-grid-mobile',
    templateUrl: './fc-responsive-ag-grid-mobile.component.html',
    styleUrls: ['./fc-responsive-ag-grid-mobile.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FcResponsiveAgGridMobileComponent {

    /**
     * Fc Responsive Ag Grid Options.
     */
    @Input() gridOptions: FcResponsiveAgGridOptions;
    
    /**
     * Default constructor.
     */
    constructor() {
    }

}